import { CalendarMonth, ChevronLeft, ChevronRight } from "@mui/icons-material";
import {
  Box,
  Button,
  ButtonGroup,
  Card,
  Checkbox,
  IconButton,
  MenuItem,
  TextField,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { Views } from "react-big-calendar";
import { useTheme } from "@emotion/react";

import {
  DesktopDatePicker,
  LocalizationProvider,
  StaticDatePicker,
} from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

import dayjs from "dayjs";
import utc from "dayjs/plugin/utc"; // ES 2015
import timezone from "dayjs/plugin/timezone"; // ES 2015
import isoWeek from "dayjs/plugin/isoWeek"; // ES 2015
import SelectWorkStation from "./SelectWorkStation";
import SelectMultipleShopEmployees from "./SelectMultipleShopEmployees";
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(isoWeek);
const DEFAULT_TIMEZONE = "America/Phoenix";
dayjs.tz.setDefault(DEFAULT_TIMEZONE);

const CalendarToolBar = ({
  view,
  date,
  onNavigate,
  handleOnChangeView,
  entity,
  handleEntityFilter,
  assignedTo,
  handleAssignedToFilter,
  workStation,
  handleWorkStationFilter,
  isAdmin,
}) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const isMediumScreen = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Box sx={{ position: "relative", width: "100%", padding: "8px" }}>
      {isMediumScreen ? (
        <Box
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <IconButton
            onClick={() => {
              let day = dayjs(date).tz(DEFAULT_TIMEZONE).startOf("d");
              switch (view) {
                case Views.MONTH:
                case "linear_month":
                  day = day.subtract(1, "month");
                  day = day.startOf("month");
                  break;
                case Views.WEEK:
                  day = day.subtract(1, "week");
                  day = day.startOf("isoWeek");
                  break;
                case Views.DAY:
                  day = day.subtract(1, "day");
                  day = day.startOf("day");
                  break;
              }
              onNavigate(day);
            }}
          >
            <ChevronLeft />
          </IconButton>

          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DesktopDatePicker
              inputFormat="ddd MM/DD/YY" // display format
              label="Date (Phoenix Arizona)"
              // BY DEFAULT, DAYJS.format() will format in local time and not UTC
              // So the YYYY-MM-DD we're parsing out will be accurate
              // value={getPhoenixDayJs(isoDateParam)}
              value={
                date ? dayjs(date).tz(DEFAULT_TIMEZONE).startOf("d") : null
              }
              onChange={(newValue) => {
                onNavigate(dayjs(newValue).tz(DEFAULT_TIMEZONE).startOf("d"));
              }}
              renderInput={(params) => (
                <TextField size="small" sx={{ width: "200px" }} {...params} />
              )}
            />
          </LocalizationProvider>

          <IconButton
            onClick={() => {
              let day = dayjs(date).tz(DEFAULT_TIMEZONE).startOf("d");
              switch (view) {
                case Views.MONTH:
                case "linear_month":
                  day = day.add(1, "month");
                  day = day.startOf("month");
                  break;
                case Views.WEEK:
                  day = day.add(1, "week");
                  day = day.startOf("isoWeek");
                  break;
                case Views.DAY:
                  day = day.add(1, "day");
                  day = day.startOf("day");
                  break;
              }
              onNavigate(day);
            }}
          >
            <ChevronRight />
          </IconButton>
        </Box>
      ) : (
        <Box
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            {/* <DesktopDatePicker */}
            <StaticDatePicker
              displayStaticWrapperAs="desktop"
              inputFormat="ddd MM/DD/YY" // display format
              label="Date (Phoenix Arizona)"
              // BY DEFAULT, DAYJS.format() will format in local time and not UTC
              // So the YYYY-MM-DD we're parsing out will be accurate
              // value={getPhoenixDayJs(isoDateParam)}
              value={
                date ? dayjs(date).tz(DEFAULT_TIMEZONE).startOf("d") : null
              }
              onChange={(newValue) => {
                onNavigate(dayjs(newValue).tz(DEFAULT_TIMEZONE).startOf("d"));
              }}
              renderInput={(params) => (
                <TextField size="small" sx={{ width: "200px" }} {...params} />
              )}
            />
          </LocalizationProvider>
        </Box>
      )}

      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
          marginTop: isSmallScreen ? "8px" : 0,
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: isSmallScreen ? "column" : "row",
            alignItems: "center",
          }}
        >
          <ButtonGroup>
            {isAdmin && (
              <Button
                size="small"
                variant={view == Views.MONTH ? "contained" : "outlined"}
                onClick={() => {
                  handleOnChangeView(Views.MONTH);
                }}
              >
                Calendar
              </Button>
            )}
            {isAdmin && (
              <Button
                size="small"
                variant={view == "linear_month" ? "contained" : "outlined"}
                onClick={() => {
                  handleOnChangeView("linear_month");
                }}
              >
                Month
              </Button>
            )}
            <Button
              size="small"
              variant={view == Views.WEEK ? "contained" : "outlined"}
              onClick={() => {
                handleOnChangeView(Views.WEEK);
              }}
            >
              Week
            </Button>
            <Button
              size="small"
              variant={view == Views.DAY ? "contained" : "outlined"}
              onClick={() => {
                handleOnChangeView(Views.DAY);
              }}
            >
              Day
            </Button>
          </ButtonGroup>
        </Box>
      </Box>

      {/* <Box
        sx={{
          marginTop: "16px",
          paddingLeft: "8px",
          paddingRight: "8px",
          width: "100%",
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <TextField
          size="small"
          select
          variant="outlined"
          label="View"
          id="view"
          name="view"
          fullWidth
          value={view}
          onChange={(e) => {
            handleOnChangeView(e.target.value);
          }}
        >
          {isAdmin && <MenuItem value={Views.MONTH}>Calendar</MenuItem>}
          {isAdmin && <MenuItem value={"linear_month"}>Month</MenuItem>}
          <MenuItem value={Views.WEEK}>Week</MenuItem>
          <MenuItem value={Views.DAY}>Day</MenuItem>
        </TextField>
      </Box> */}

      <Box sx={{ marginTop: "16px", paddingLeft: "8px", paddingRight: "8px" }}>
        <TextField
          size="small"
          select
          variant="outlined"
          label="Jobs For"
          id="eventEntity"
          name="eventEntity"
          fullWidth
          value={entity ?? "ALL"}
          onChange={(e) => {
            handleEntityFilter(e.target.value);
          }}
        >
          <MenuItem value={"ALL"}>ALL</MenuItem>
          <MenuItem value={"IND"}>IND</MenuItem>
          <MenuItem value={"RFL"}>RFL</MenuItem>
        </TextField>
      </Box>
      <Box sx={{ marginTop: "16px", paddingLeft: "8px", paddingRight: "8px" }}>
        <SelectWorkStation
          size="small"
          fullWidth
          label="Work Station"
          value={workStation ? { id: workStation } : null}
          onUpdate={(workStationId) => {
            handleWorkStationFilter(workStationId);
          }}
        />
      </Box>
      <Box
        sx={{
          marginTop: "16px",
          paddingLeft: "8px",
          paddingRight: "8px",
        }}
      >
        <SelectMultipleShopEmployees
          size="small"
          fullWidth
          label="Assigned To"
          value={
            assignedTo
              ? assignedTo.split(",").map((userId) => {
                  return { id: Number(userId) };
                })
              : []
          }
          onUpdate={(users) => {
            // formik.setFieldValue("assignedTo", users);
            let assignedToIds = [];
            for (let user of users) {
              assignedToIds.push(user.id);
            }
            handleAssignedToFilter(assignedToIds);
          }}
        />
      </Box>
    </Box>
  );
};

export default CalendarToolBar;
